import {
  primaryColor, primaryHeadingColor,
  wMedium, secondaryFont,
  maxWidth,
  retina,
  searchLoaderGrid,
} from 'Utils/utilsStyle';
import React from 'react';
import styled from 'styled-components';

const StyleWrapper = styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
height: inherit;
width: 200px;
.main{
    background:white;
    border:1px solid ${primaryColor};
    padding: 12px 15px;
    text-align: center;
    border-radius:16px;
    margin:0 18px;
    .loader-style{
      height: 87px;
      width: 175px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        transform: scale(0.8);
      }
    }
  }
`;

const ExtendedSearchLoader = function ExtendedSearchLoader() {
  return (
    <StyleWrapper className="extended-search-loader-wrapper">
      <div className="main">
        <img className="loader-style" src={searchLoaderGrid} alt="extended-loader" />
      </div>
    </StyleWrapper>
  );
};
export default ExtendedSearchLoader;
